<template>
  <div class="mine">
    <bread :list="list"></bread>
    <i class="line"></i>

    <div class="flex justify-between margin-tb-40 text-16">
      <div class="margin-right-40">
        <img class="radius-50p _cover" :src="info.logo!=null && info.logo?info.logo:$nodata" alt />
      </div>
      <div class="flex-grow flex flex-column justify-between">
        <div class="flex line-30">
          <div class="margin-right-80">
            尊敬的
            <span class="c-ff6">{{user.grade_name}}</span> 会员
            <span class="c-ff6">{{name}}</span>，欢迎您回到用户中心！
          </div>
          <div v-if="user.grade_id">用户有效期至：{{user.end_time}}</div>
        </div>
        <div class="flex justify-between mine_apply text-content">
          <div>
            <p class="text-10">招商申请量</p>
            <p class="text-16">{{data.zs_apply_num ? data.zs_apply_num : 0}}</p>
          </div>
          <div>
            <p class="text-10">资讯申请量</p>
            <p class="text-16">{{data.zx_apply_num ? data.zx_apply_num : 0}}</p>
          </div>
          <div>
            <p class="text-10">名片收藏量</p>
            <p class="text-16">{{data.collect_num ? data.collect_num: 0}}</p>
          </div>
          <div>
            <p class="text-10">名片浏览量</p>
            <p class="text-16">{{data.attention_num ? data.attention_num : 0}}</p>
          </div>
          <div>
            <p class="text-10">资讯浏览量</p>
            <p class="text-16">{{data.article_num ? data.article_num : 0}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="mine_title">系统公告</div>
    <div class="flex justify-between" style="height: 600px;">
      <div class="mine_l">
        <el-table class="poi" :data="NewList.data" style="width: 100%" @cell-click="to">
          <el-table-column prop="news_title" label="标题"></el-table-column>
          <el-table-column prop="news_time" label="时间" width="180"></el-table-column>
        </el-table>
        <div class="text-center margin-top-40">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :total="NewList.count"
            layout="prev, pager, next"
            @cell-click="to(item.id)"
          ></el-pagination>
        </div>
      </div>
      <div class="mine_img margin-left-40">
        <img
          v-for="(item, index) in data.ad_data"
          :key="index"
          @click="go(item.url)"
          class="poi"
          :src="item.thumb"
          :alt="item.title"
        />
      </div>
    </div>
  </div>
</template>

<script>
import bread from "../../components/bread";
export default {
  components: {
    bread
  },
  data() {
    return {
      user: "",
      name: "",
      info: JSON.parse(window.localStorage.getItem("ent_info")),
      data: "",
      NewList: "",
      list: [
        {
          title: "用户中心"
        }
      ]
    };
  },
  created() {
    this.getUser(); //获取企业等级信息
    this.getName();
    this.getData();
    this.getNew();
  },
  methods: {
    handleCurrentChange(val) {
      this.getNew(val);
    },
    // 广告 浏览量
    getData() {
      this.post(this, "/home/news/data", {
        token: window.localStorage.getItem("pc_token")
      }).then(res => {
        this.data = res.data.data;
      });
    },
    // 新闻
    getNew(page) {
      this.post(this, "/home/news/list/data", {
        token: window.localStorage.getItem("pc_token"),
        page: page ? page : 0,
        limit: 10
      }).then(res => {
        this.NewList = res.data;
      });
    },
    // 获取企业等级信息
    getUser() {
      this.post(this, "/home/entGradename", {
        token: window.localStorage.getItem("pc_token")
      }).then(res => {
        if (res.data.data.end_time) {
          res.data.data.end_time = this.getDate(res.data.data.end_time);
        }
        this.user = res.data.data;
      });
    },
    // 时间戳转换
    getDate(time) {
      var oDate = new Date(time * 1000),
        oYear = oDate.getFullYear(),
        oMonth = oDate.getMonth() + 1,
        oDay = oDate.getDate();
      if (oMonth < 10) {
        oMonth = "0" + oMonth;
      }
      if (oDay < 10) {
        oDay = "0" + oDay;
      }
      var oTime = oYear + "-" + oMonth + "-" + oDay; //最后拼接时间
      return oTime;
    },
    // 获取名称
    getName() {
      this.name = JSON.parse(window.localStorage.getItem("ent_info")).e_name;
    },
    go(path) {
      window.open(path, "_blank")
    },
    to(row) {
      this.$router.push("./new?id=" + row.id);
    }
  }
};
</script>

<style scoped>
.tit_a {
  font-size: 18px;
  color: #343434;
}
.tit_a em {
  color: #ff6634;
  cursor: pointer;
  font-style: normal;
}
.c-ff6 {
  color: #ff6634;
}
.mine_list {
  width: 80%;
  word-break: break-all;
  transition: 0.35s;
}

.mine_list:hover {
  color: #2b2b2b;
}

.mine_ul {
  width: 60%;
  border: 1px solid black;
  border-radius: 10px;
  padding: 0 20px;
  line-height: 1.6;
  color: #999;
}

.mine_cont {
  height: 600px;
}

.mine_title {
  line-height: 80px;
  font-size: 24px;
  color: black;
}

.mine_img {
  width: 35%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.mine_img img {
  width: 100%;
  height: 30%;
  border-radius: 10px;
  
}

.mine_li {
  font-size: 14px;
  height: 10%;
}

.mine_h {
  height: 80%;
}

.mine_apply div {
  width: 18%;
  text-align: left;
  background: #f8f8f8;
  color: #0c9b8d;
  padding: 10px;
  border-radius: 5px;
}

/*  */
._cover {
  width: 100px;
  height: 100px;
}

.mine_l {
  min-width: 60%;
}
</style>

<style>
.mine .el-pagination .el-pager .active {
  background: black !important;
}
.mine .el-pagination .el-pager .number {
  background: white;
  border: 1px solid #eee;
}
.btn-prev,
.btn-next {
  background: white !important;
}
.el-icon-more {
  background: white !important;
}
</style>